import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PhraseLocale } from '@/api/translations';

import { type I18nState } from './store.type';

export const initialI18nState: I18nState = {
  availableLanguages: [],
};

export const i18nSlice = createSlice({
  name: 'i18n',
  initialState: initialI18nState,
  reducers: {
    updateAvailableLanguages: (state, action: PayloadAction<PhraseLocale[]>) => {
      state.availableLanguages = action.payload;
    },
  },
});

export const { updateAvailableLanguages } = i18nSlice.actions;

export default i18nSlice.reducer;
